import React from 'react';
import Icon from '../../../components/AppIcon';

const FilterControls = ({ filters, onFilterChange, onResetFilters }) => {
  
  const interestAreas = [
    { value: 'sciences', label: 'Sciences & Mathématiques' },
    { value: 'technologie', label: 'Technologie & Ingénierie' },
    { value: 'economie', label: 'Économie, Gestion & Finance' },
    { value: 'langues', label: 'Langues & Littérature' },
    { value: 'sante', label: 'Santé & Médecine' },
    { value: 'droit', label: 'Droit & Sciences Po' },
    { value: 'arts', label: 'Arts & Design' }
  ];

  // CORRECTION ICI : Les 'value' sont maintenant sans accents et en minuscules
  // pour correspondre parfaitement aux tags des données.
  const preferredSubjects = [
    { value: 'mathematiques', label: 'Mathématiques' },
    { value: 'physique', label: 'Physique-Chimie' },
    { value: 'svt', label: 'SVT' },
    { value: 'francais', label: 'Français' },     // 'francais' sans cédille
    { value: 'anglais', label: 'Anglais' },
    { value: 'histoire', label: 'Histoire-Géo' },
    { value: 'philosophie', label: 'Philosophie' },
    { value: 'economie', label: 'Économie / Gestion' }
  ];

  const difficultyLevels = [
    { value: 'accessible', label: 'Accessible' },
    { value: 'moyen', label: 'Moyen' },
    { value: 'eleve', label: 'Élevé (Challenge)' }
  ];

  const hasActiveFilters = 
    filters?.interestArea || 
    (filters?.preferredSubjects && filters.preferredSubjects.length > 0) ||
    (filters?.difficultyLevels && filters.difficultyLevels.length > 0);

  const handleCheckboxChange = (category, value, checked) => {
    const currentValues = filters?.[category] || [];
    let newValues;
    
    if (checked) {
      newValues = [...currentValues, value];
    } else {
      newValues = currentValues.filter(item => item !== value);
    }
    
    onFilterChange(category, newValues);
  };

  return (
    <div className="bg-card border border-border rounded-xl p-6 shadow-sm font-sans animate-fade-in">
      {/* Header */}
      <div className="flex items-center justify-between mb-6 pb-4 border-b border-border">
        <div className="flex items-center space-x-2">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="text-lg font-bold text-foreground">Filtres</h3>
        </div>
        {hasActiveFilters && (
          <button
            onClick={onResetFilters}
            className="text-xs font-medium text-red-600 hover:text-red-700 bg-red-50 hover:bg-red-100 px-2 py-1 rounded transition-colors flex items-center"
          >
            <Icon name="X" size={12} className="mr-1" />
            Effacer
          </button>
        )}
      </div>

      <div className="space-y-8">
        
        {/* Domaine d'intérêt */}
        <div>
          <label className="block text-sm font-bold text-foreground mb-2">
            Domaine Principal
          </label>
          <div className="relative">
            <select
              className="w-full p-2.5 bg-background border border-border rounded-lg appearance-none focus:ring-2 focus:ring-primary/20 outline-none transition-all text-sm font-medium cursor-pointer"
              value={filters?.interestArea || ''}
              onChange={(e) => onFilterChange('interestArea', e.target.value)}
            >
              <option value="">Tous les domaines...</option>
              {interestAreas.map((area) => (
                <option key={area.value} value={area.value}>{area.label}</option>
              ))}
            </select>
            <div className="absolute right-3 top-3 pointer-events-none text-muted-foreground">
              <Icon name="ChevronDown" size={16} />
            </div>
          </div>
        </div>

        {/* Matières Préférées */}
        <div>
          <label className="block text-sm font-bold text-foreground mb-3 flex items-center">
            Matières Fortes
            <span className="ml-2 text-[10px] font-normal text-muted-foreground bg-muted px-1.5 py-0.5 rounded">Multiple</span>
          </label>
          <div className="grid grid-cols-2 gap-2">
            {preferredSubjects.map((subject) => {
              const isChecked = filters?.preferredSubjects?.includes(subject.value);
              return (
                <label 
                  key={subject.value} 
                  className={`
                    flex items-center p-2 rounded-lg border cursor-pointer transition-all text-xs font-medium
                    ${isChecked 
                      ? 'bg-primary/5 border-primary text-primary' 
                      : 'bg-background border-border text-muted-foreground hover:bg-muted/50'
                    }
                  `}
                >
                  <input
                    type="checkbox"
                    className="hidden"
                    checked={isChecked || false}
                    onChange={(e) => handleCheckboxChange('preferredSubjects', subject.value, e.target.checked)}
                  />
                  <div className={`w-3.5 h-3.5 rounded border mr-2 flex items-center justify-center flex-shrink-0 ${isChecked ? 'bg-primary border-primary' : 'border-muted-foreground'}`}>
                    {isChecked && <Icon name="Check" size={10} className="text-white" />}
                  </div>
                  <span className="truncate">{subject.label}</span>
                </label>
              );
            })}
          </div>
        </div>

        {/* Niveau de difficulté */}
        <div>
          <label className="block text-sm font-bold text-foreground mb-3">
            Niveau de Difficulté
          </label>
          <div className="space-y-2">
            {difficultyLevels.map((level) => {
               const isChecked = filters?.difficultyLevels?.includes(level.value);
               return (
                <label 
                    key={level.value}
                    className="flex items-center space-x-3 cursor-pointer group"
                >
                    <div className={`w-4 h-4 rounded border flex items-center justify-center transition-colors ${isChecked ? 'bg-secondary border-secondary' : 'bg-background border-muted-foreground group-hover:border-secondary'}`}>
                        {isChecked && <Icon name="Check" size={12} className="text-white" />}
                    </div>
                    <input
                        type="checkbox"
                        className="hidden"
                        checked={isChecked || false}
                        onChange={(e) => handleCheckboxChange('difficultyLevels', level.value, e.target.checked)}
                    />
                    <span className={`text-sm ${isChecked ? 'text-foreground font-medium' : 'text-muted-foreground'}`}>
                        {level.label}
                    </span>
                </label>
               );
            })}
          </div>
        </div>

        {/* Résumé */}
        {hasActiveFilters && (
          <div className="pt-4 border-t border-border animate-fade-in">
            <p className="text-xs font-semibold text-muted-foreground mb-2">Filtres actifs :</p>
            <div className="flex flex-wrap gap-1.5">
              {filters?.interestArea && (
                <span className="px-2 py-0.5 bg-blue-50 text-blue-700 rounded text-[10px] font-bold border border-blue-100">
                  {interestAreas.find(a => a.value === filters.interestArea)?.label}
                </span>
              )}
              {filters?.difficultyLevels?.map(l => (
                 <span key={l} className="px-2 py-0.5 bg-gray-100 text-gray-700 rounded text-[10px] font-bold border border-gray-200">
                    {difficultyLevels.find(dl => dl.value === l)?.label}
                 </span>
              ))}
               {filters?.preferredSubjects?.length > 0 && (
                 <span className="px-2 py-0.5 bg-purple-50 text-purple-700 rounded text-[10px] font-bold border border-purple-100">
                    {filters.preferredSubjects.length} Matières
                 </span>
              )}
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default FilterControls;